import React from 'react';
import '../styling/componentStyles.css'

interface LabelProps{
    content: String;
}

export const Label: React.FC<LabelProps> = (props: LabelProps) =>{
    const{
       content
    } = props;
        
        return (
            <div className='label'>
                <label>{content}</label>
            </div>
        )
    }

export default Label